<div class="card step-card flex flex-column">
  <div class="grid">
    <div class="col-12">
      <div class="flex flex-column sm:flex-row justify-content-between mb-2">
        <span (click)="fileInput.click()"
              [label]="'misc.importConfigurationJSON' | transloco"
              class="p-button-primary flex-1 sm:flex-none sm:mb-0 mb-2"
              icon="pi pi-file-import"
              iconPos="left"
              pButton pRipple>
          <input
            #fileInput
            (change)="onFileChange($event)"
            accept=".json"
            hidden
            id="sequence-configuration-json"
            type="file"
          >
        </span>
        <div class="flex w- sm:w-auto sm:flex-row">
          <button
            (click)="reloadTemplate()"
            [disabled]="!loaded"
            [label]="'misc.sequence.restoreConfiguration' | transloco"
            class="p-button-secondary sm:flex-order-0 sm:mb-0 mb-2"
            icon="pi pi-refresh"
            iconPos="left"
            pButton
            pRipple
            type="button"
          >
          </button>
          <button
            (click)="showErrors.emit()"
            *ngIf="errors.length !== 0"
            [disabled]="!loaded"
            [label]="'misc.sequence.readConfigurationErrors' | transloco"
            class="p-button-warning sm:flex-order-0 sm:mb-0 mb-2 ml-2"
            icon="pi pi-exclamation-triangle"
            iconPos="left"
            pButton
            pRipple
            type="button"
          >
          </button>
        </div>

      </div>
      <ng-container *ngIf="loaded">
        <form [formGroup]="configurationForm" class="fadein">
          <json-editor
            (change)="isValidSchema()"
            [options]="jsonEditorOptions"
            class="w-full"
            formControlName="configuration"
          ></json-editor>
        </form>
      </ng-container>
      <ng-container *ngIf="!loaded">
        <p-skeleton class="w-full" height="486.82px"></p-skeleton>
      </ng-container>
    </div>

  </div>

  <div class="mt-auto">
    <div class="flex flex-column sm:flex-row justify-content-between">
      <div class="flex justify-content-between sm:justify-content-start sm:flex-order-1">
        <button
          (click)="onPrevStep()"
          [label]="'common.previous' | transloco"
          class="flex-1 sm:flex-none"
          icon="pi pi-angle-left"
          iconPos="left"
          pButton
          pRipple
        ></button>
        <button
          (click)="onNextStep()"
          [disabled]="isValid === undefined ? true : !isValid"
          [label]="'common.next'| transloco"
          class="p-button-primary ml-2 flex-1 sm:flex-none"
          icon="pi pi-angle-right"
          iconPos="right"
          pButton
          pRipple
        ></button>
      </div>
      <button
        (click)="cancel()"
        [label]="'common.cancel' | transloco"
        class="p-button-danger mt-2 sm:mt-0 sm:flex-order-0"
        pButton
        pRipple
      ></button>
    </div>
  </div>
</div>
